module.exports = __webpack_public_path__ + "static/media/btn-unknow.162cce08.svg";